import apiClient from "../../../utils/clients/axios";

export const getMilkList = async (date) => {
  console.log("myDate", { date });
  const { data } = await apiClient.get(`/milk?date=${date}`);
  return data;
};

export const updateMilkStatus = async (payload) => {
  const response = await apiClient.patch(`/milk/?id=${payload.id}`, {
    quantity: payload.quantity,
  });
  return response;
};

export const getGuestList = async (date) => {
  const { data } = await apiClient.get(`/guests/?date=${date}`);

  console.log({ data });
  return data;
};

export const updateGuestStatus = async (payload) => {
  const response = await apiClient.patch(`/guests?id=${payload.id}`, {
    ...(payload.relationship && { relationship: payload.relationship }),
    ...(payload.organization && { relationship: payload.organization }),
  });

  return response;
};

export const getMaterialInwardList = async (date) => {
  const { data } = await apiClient.get(`/materialinward?date=${date}`);

  console.log({ data });
  return data;
};

export const updateMaterialInwardStatus = async (payload) => {
  const response = await apiClient.patch(`/materialinward?id=${payload.id}`, {
    invoice_num: payload.invoice_num,
  });

  return response;
};

export const getMaterialOutwardList = async (date) => {
  const { data } = await apiClient.get(`/materialoutward?date=${date}`);
  return data;
};

export const updateMaterialOutwardStatus = async (payload) => {
  const response = await apiClient.patch(`/materialoutward?id=${payload.id}`, {
    invoice_num: payload.invoice_num,
  });

  return response;
};

export const getMaterialReturnalableList = async (date) => {
  const { data } = await apiClient.get(`/returnablematerials?date=${date}`);
  return data;
};

export const updateMaterialReturnableStatus = async (id, payload) => {
  console.log({ id, payload });
  const response = await apiClient.patch(
    `/returnablematerials/id=${id}`,
    payload
  );

  return response;
};

export const getKeyList = async (date) => {
  const { data } = await apiClient.get(`/keys?date=${date}`); // need to change

  return data;
};

export const updateKeyListStatus = async (payload) => {
  const response = await apiClient.patch(`/keys/id=${payload.id}`, {
    key_type: payload.key_type,
  }); //need to change

  return response;
};
